import httpClient, { requestData } from './httpClient';

const dataMethods = new Set(['get', 'post', 'put', 'patch', 'delete']);

const dataApi = new Proxy(httpClient, {
  get(target, prop) {
    const value = target[prop];

    if (typeof value !== 'function' || !dataMethods.has(prop)) {
      return value;
    }

    return (...args) => {
      const config = args[args.length - 1];
      const request = value.apply(target, args);

      if (config?.responseType === 'blob') {
        return request;
      }

      return requestData(request);
    };
  },
});

export default dataApi;
